import { useState } from 'react';
import FreeTrialModal from './FreeTrialModal';

export default function FloatingCTA() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="fixed bottom-4 left-0 right-0 z-50 px-6">
        <div className="max-w-lg mx-auto">
          <button
            onClick={() => setShowModal(true)}
            className="w-full h-14 bg-[#FF6B35] text-white rounded-full font-bold text-base shadow-2xl hover:bg-[#FF6B35]/90 transition-all flex items-center justify-center gap-2 whitespace-nowrap"
          >
            <i className="ri-phone-line text-xl"></i>
            <span>無料体験を申し込む</span>
          </button>
        </div>
      </div>

      {showModal && <FreeTrialModal onClose={() => setShowModal(false)} />}
    </>
  );
}
